import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FetchMainProductListService } from '../../../utils/services/master/product.service';
import { FetchUnitListService } from '../../../utils/services/master/unit.service';
import { FetchPackageListService, FetchPackageMaterialListService, FetchPackageTypeListService } from '../../../utils/services/master/packages.service';
import { FetchSpecificationListService } from '../../../utils/services/master/specification.service';
import { FetchCustomersListService } from '../../../utils/services/master/customer.service';
import { CustomerType } from '../../../utils/dto/response';
import { FetchCountryListService } from '../../../utils/services/master/ports.service';
import { FetchProformaInvoiceListService } from '../../../utils/services/proforma.Invoice.service';
import { FetchLCMasterListService } from '../../../utils/services/master/lc.service';
import { FetchBrokerListService, FetchSalesPersonListService } from '../../../utils/services/users.service';
import { FetchBankDetailsListService } from '../../../utils/services/master/bank.service';
import { FetchShipmentTermListService } from '../../../utils/services/master/shipment.service';
import { FetchPaymentTermListService } from '../../../utils/services/master/payment.service';
import { FetchAdvanceLincenseListService, FetchEPCGLincenseListService } from '../../../utils/services/master/license.service';
import { FetchCurrencyListService } from '../../../utils/services/master/currency.service';
import { InvoiceType } from '../../../utils/dto/response/export-docs/invoice';
import { FetchRemarksListService } from '../../../utils/services/master/remarks.service';
import { FetchDeclarationsListService } from '../../../utils/services/master/declaration.service';
import { FetchCustomerGroupsListService } from '../../../utils/services/master/customer-groups.service';

type InitialStateType = {
    loading: boolean
    productsList: [],
    unitsList: [],
    packageList: [],
    packageTypeList: [],
    packageMaterialList: [],
    qualitySpecificationList: [],
    customersList: CustomerType[] | [],
    countriesList: [],
    proformaInvoiceList: [],
    invoiceList: InvoiceType[],
    LCList: [],
    brokerList: [],
    salesPersonList: [],
    bankList: [],
    shipmentTermsList: [],
    paymentTermsList: [],
    advanceLincenseList: [],
    EPCGLincenseList: [],
    currencyList: [],
    remarkList: [],
    declarationList: [],
    customerGroupsList: [],
}

export const fetchProductsList = createAsyncThunk(
    'api/fetchProductsList',
    async () => {
        const { code, data } = await FetchMainProductListService({})
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

export const fetchUnitsList = createAsyncThunk(
    'api/fetchUnitsList',
    async () => {
        const { code, data } = await FetchUnitListService({})
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

export const fetchPackageList = createAsyncThunk(
    'api/fetchPackageList',
    async () => {
        const { code, data } = await FetchPackageListService({});
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

export const fetchPackageTypeList = createAsyncThunk(
    'api/fetchPackageTypeList',
    async () => {
        const { code, data } = await FetchPackageTypeListService({});
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

export const fetchPackageMaterialList = createAsyncThunk(
    'api/fetchPackageMaterialList',
    async () => {
        const { code, data } = await FetchPackageMaterialListService({});
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

export const fetchQualitySpecificationList = createAsyncThunk(
    'api/fetchQualitySpecificationList',
    async () => {
        const { code, data } = await FetchSpecificationListService({});
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

export const fetchCustomersList = createAsyncThunk(
    'api/fetchCustomersList',
    async () => {
        const { code, data } = await FetchCustomersListService({ is_active: true })
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

export const fetchCountriesList = createAsyncThunk(
    'api/fetchCountriesList',
    async () => {
        const { code, data } = await FetchCountryListService({})
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

// =====
export const fetchProformaInvoiceList = createAsyncThunk(
    'api/fetchProformaInvoiceList',
    async () => {
        const { code, data } = await FetchProformaInvoiceListService({});
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

// export const fetchInvoiceList = createAsyncThunk(
//     'api/fetchInvoiceList',
//     async () => {
//         const { code, data } = await FetchInvoiceListService({})
//         if (code === 200 && data && data.data) {
//             return data.data
//         } else {
//             return []
//         }
//     }
// );

export const fetchLCList = createAsyncThunk(
    'api/fetchLCList',
    async () => {
        const { code, data } = await FetchLCMasterListService({});
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

export const fetchBrokerList = createAsyncThunk(
    'api/fetchBrokerList',
    async () => {
        const { code, data } = await FetchBrokerListService({});
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

export const fetchSalesPersonList = createAsyncThunk(
    'api/fetchSalesPersonList',
    async () => {
        const { code, data } = await FetchSalesPersonListService({})
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);
export const fetchBankList = createAsyncThunk(
    'api/fetchBankList',
    async () => {
        const { code, data } = await FetchBankDetailsListService({})
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);
export const fetchShipmentTermsList = createAsyncThunk(
    'api/fetchShipmentTermsList',
    async () => {
        const { code, data } = await FetchShipmentTermListService({})
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);
export const fetchPaymentTermsList = createAsyncThunk(
    'api/fetchPaymentTermsList',
    async () => {
        const { code, data } = await FetchPaymentTermListService({})
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

export const fetchAdvanceLincenseList = createAsyncThunk(
    'api/fetchAdvanceLincenseList',
    async () => {
        const { code, data } = await FetchAdvanceLincenseListService({});
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

export const fetchEPCGLincenseList = createAsyncThunk(
    'api/fetchEPCGLincenseList',
    async () => {
        const { code, data } = await FetchEPCGLincenseListService({});
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

export const fetchCurrencyList = createAsyncThunk(
    'api/fetchCurrencyList',
    async () => {
        const { code, data } = await FetchCurrencyListService({})
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

export const fetchRemarkList = createAsyncThunk(
    'api/fetchRemarkList',
    async () => {
        const { code, data } = await FetchRemarksListService({})
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

export const fetchDeclarationList = createAsyncThunk(
    'api/fetchDeclarationList',
    async () => {
        const { code, data } = await FetchDeclarationsListService({})
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

export const fetchCustomerGroupsList = createAsyncThunk(
    'api/fetchCustomerGroupsList',
    async () => {
        const { code, data } = await FetchCustomerGroupsListService({})
        if (code === 200 && data && data.data) {
            return data.data
        } else {
            return []
        }
    }
);

const initialState: InitialStateType = {
    loading: false,
    productsList: [],
    unitsList: [],
    packageList: [],
    packageTypeList: [],
    packageMaterialList: [],
    qualitySpecificationList: [],
    customersList: [],
    countriesList: [],
    proformaInvoiceList: [],
    invoiceList: [],
    LCList: [],
    brokerList: [],
    salesPersonList: [],
    bankList: [],
    shipmentTermsList: [],
    paymentTermsList: [],
    advanceLincenseList: [],
    EPCGLincenseList: [],
    currencyList: [],
    remarkList: [],
    declarationList: [],
    customerGroupsList: []
}

const mastersSlice = createSlice({
    name: 'masters',
    initialState,
    reducers: {
        resetProductList: (state) => {
            state.productsList = [];
        },
        resetUnitsList: (state) => {
            state.unitsList = [];
        },
        resetPackageList: (state) => {
            state.packageList = [];
        },
        resetCurrencyList: (state) => {
            state.currencyList = [];
        },
        resetPackageTypeList: (state) => {
            state.packageTypeList = [];
        },
        resetPackageMaterialList: (state) => {
            state.packageMaterialList = [];
        },
        resetQualitySpecificationList: (state) => {
            state.packageMaterialList = [];
        },
        resetCustomersList: (state) => {
            state.customersList = [];
        },
        resetSalesPersonList: (state) => {
            state.salesPersonList = [];
        },
        resetCountriesList: (state) => {
            state.countriesList = [];
        },
        resetProformaInvoiceList: (state) => {
            state.proformaInvoiceList = [];
        },
        resetInvoiceList: (state) => {
            state.invoiceList = [];
        },
        resetPaymentTermsList: (state) => {
            state.paymentTermsList = [];
        },
        resetShipmentTermsList: (state) => {
            state.shipmentTermsList = [];
        },
        resetBrokerList: (state) => {
            state.brokerList = [];
        },
        resetBankList: (state) => {
            state.bankList = [];
        },
        resetRemarkList: (state) => {
            state.remarkList = [];
        },
        resetDeclarationList: (state) => {
            state.remarkList = [];
        },
        resetCustomerGroupsList: (state) => {
            state.customerGroupsList = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductsList.pending, (state) => {
                state.loading = true;
                state.productsList = []
            })
            .addCase(fetchProductsList.fulfilled, (state, action) => {
                state.loading = false;
                state.productsList = action.payload;
            })
            .addCase(fetchUnitsList.pending, (state) => {
                state.loading = true;
                state.unitsList = []
            })
            .addCase(fetchUnitsList.fulfilled, (state, action) => {
                state.loading = false;
                state.unitsList = action.payload;
            })
            .addCase(fetchPackageList.pending, (state) => {
                state.loading = true;
                state.packageList = []
            })
            .addCase(fetchPackageList.fulfilled, (state, action) => {
                state.loading = false;
                state.packageList = action.payload;
            })
            .addCase(fetchPackageTypeList.pending, (state) => {
                state.loading = true;
                state.packageTypeList = []
            })
            .addCase(fetchPackageTypeList.fulfilled, (state, action) => {
                state.loading = false;
                state.packageTypeList = action.payload;
            })
            .addCase(fetchPackageMaterialList.pending, (state) => {
                state.loading = true;
                state.packageMaterialList = []
            })
            .addCase(fetchPackageMaterialList.fulfilled, (state, action) => {
                state.loading = false;
                state.packageMaterialList = action.payload;
            })
            .addCase(fetchQualitySpecificationList.pending, (state) => {
                state.loading = true;
                state.qualitySpecificationList = []
            })
            .addCase(fetchQualitySpecificationList.fulfilled, (state, action) => {
                state.loading = false;
                state.qualitySpecificationList = action.payload;
            })
            .addCase(fetchCustomersList.pending, (state) => {
                state.loading = true;
                state.customersList = []
            })
            .addCase(fetchCustomersList.fulfilled, (state, action) => {
                state.loading = false;
                state.customersList = action.payload;
            })
            .addCase(fetchCountriesList.pending, (state) => {
                state.loading = true;
                // state.countriesList = []
            })
            .addCase(fetchCountriesList.fulfilled, (state, action) => {
                state.loading = false;
                state.countriesList = action.payload;
            })
            .addCase(fetchProformaInvoiceList.pending, (state) => {
                state.loading = true;
                state.proformaInvoiceList = []
            })
            .addCase(fetchProformaInvoiceList.fulfilled, (state, action) => {
                state.loading = false;
                state.proformaInvoiceList = action.payload;
            })
            // .addCase(fetchInvoiceList.pending, (state) => {
            //     state.loading = true;
            //     state.invoiceList = []
            // })
            // .addCase(fetchInvoiceList.fulfilled, (state, action) => {
            //     state.loading = false;
            //     state.invoiceList = action.payload;
            // })
            .addCase(fetchLCList.pending, (state) => {
                state.loading = true;
                state.LCList = []
            })
            .addCase(fetchLCList.fulfilled, (state, action) => {
                state.loading = false;
                state.LCList = action.payload;
            })
            .addCase(fetchBrokerList.pending, (state) => {
                state.loading = true;
                state.brokerList =[]
            })
            .addCase(fetchBrokerList.fulfilled, (state, action) => {
                state.loading = false;
                state.brokerList = action.payload;
            })
            .addCase(fetchSalesPersonList.pending, (state) => {
                state.loading = true;
                state.salesPersonList = []
            })
            .addCase(fetchSalesPersonList.fulfilled, (state, action) => {
                state.loading = false;
                state.salesPersonList = action.payload;
            })
            .addCase(fetchBankList.pending, (state) => {
                state.loading = true;
                state.bankList = []
            })
            .addCase(fetchBankList.fulfilled, (state, action) => {
                state.loading = false;
                state.bankList = action.payload;
            })
            .addCase(fetchShipmentTermsList.pending, (state) => {
                state.loading = true;
                state.shipmentTermsList = []
            })
            .addCase(fetchShipmentTermsList.fulfilled, (state, action) => {
                state.loading = false;
                state.shipmentTermsList = action.payload;
            })
            .addCase(fetchPaymentTermsList.pending, (state) => {
                state.loading = true;
                state.paymentTermsList = []
            })
            .addCase(fetchPaymentTermsList.fulfilled, (state, action) => {
                state.loading = false;
                state.paymentTermsList = action.payload;
            })
            .addCase(fetchAdvanceLincenseList.pending, (state) => {
                state.loading = true;
                state.advanceLincenseList =[]
            })
            .addCase(fetchAdvanceLincenseList.fulfilled, (state, action) => {
                state.loading = false;
                state.advanceLincenseList = action.payload;
            })
            .addCase(fetchEPCGLincenseList.pending, (state) => {
                state.loading = true;
                state.EPCGLincenseList = []
            })
            .addCase(fetchEPCGLincenseList.fulfilled, (state, action) => {
                state.loading = false;
                state.EPCGLincenseList = action.payload;
            })
            .addCase(fetchCurrencyList.pending, (state) => {
                state.loading = true;
                state.currencyList = []
            })
            .addCase(fetchCurrencyList.fulfilled, (state, action) => {
                state.loading = false;
                state.currencyList = action.payload;
            })
            .addCase(fetchRemarkList.fulfilled, (state, action) => {
                state.loading = false;
                state.remarkList = action.payload;
            })
            .addCase(fetchDeclarationList.fulfilled, (state, action) => {
                state.loading = false;
                state.declarationList = action.payload;
            })
            .addCase(fetchCustomerGroupsList.pending, (state) => {
                state.loading = true;
                state.customerGroupsList = []
            })
            .addCase(fetchCustomerGroupsList.fulfilled, (state, action) => {
                state.loading = false;
                state.customerGroupsList = action.payload;
            })
    },
});

export const { resetProductList, resetProformaInvoiceList, resetSalesPersonList, resetUnitsList, resetCustomersList, resetPaymentTermsList, resetShipmentTermsList, resetBrokerList, resetCountriesList, resetBankList, resetCurrencyList, resetRemarkList, resetDeclarationList, resetCustomerGroupsList } = mastersSlice.actions;
export default mastersSlice.reducer;
